<template>
  <table class='confirmation-table confirmation-table-adjust-padding'>
    <tr>
      <td>Ingangsdatum kenmerken</td>
      <td>{{ formatDate(detail.fromDate ) }}</td>
    </tr>
    <tr v-if="detail.untilDate">
      <td>Einddatum kenmerken</td>
      <td>{{ formatDate(detail.untilDate) }}</td>
    </tr>
    <tr>
      <td>{{ 'employee.profession-class' | translate }}</td>
      <td>{{ 'profession-classification.'+detail.professionClassification | translate }}</td>
    </tr>
    <tr>
      <td>{{ 'employee.nature-of-employment' | translate }}</td>
      <td>{{ 'nature-of-employment.'+detail.natureOfEmployment | translate }}</td>
    </tr>
    <tr>
      <td>{{ 'employee.gross-annual-salary' | translate }}</td>
      <td>{{ new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(detail.grossAnnualSalary) }}</td>
    </tr>
    <tr v-if="isShowingSVSalary">
      <td>{{'employee.sv-salary' | translate }}</td>
      <td>{{ new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(detail.svSalary) }}</td>
    </tr>
    <tr>
      <td>{{ 'employee.no-risk' | translate }}</td>
      <td>{{ detail.noRisk.toString() | translate }}</td>
    </tr>
  </table>

</template>

<script>
import _ from 'lodash';
import Helpers from '@/shared/helpers/functions';
import Compositions from '@/views/helpers/compositions';

export default {
  name: 'EmployeeEmploymentRelationshipDetail',
  props: {
    detail: Object,
    employee: Object
  },
  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date)
  },
  computed: {
    isShowingSVSalary () {
      let policies = Compositions.getPoliciesFromParticipations(
        this.employee.allParticipations, this.$store.getters.policies);

      if (policies && policies.length > 0) return _.some(policies, p => p.productType === 'WIA');
      return false;
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.employment-relationship-detail {
  position: relative;
  left: -1px;
}
.confirmation-table-adjust-padding {
  td {
    &:first-child {
      padding-left: 14px;
    }
    &:last-child {
      padding-right: 14px;
    }
  }

  tr {
    &:last-child {
      td {
        border: 0;
      }
    }
  }
}
table {
  width: 100%;
}
</style>
